/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Field_Delivered_AtInputs */

const vi_cdo_field_delivered_at = /** @type {(inputs: Cdo_Field_Delivered_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao lúc`)
};

/**

* @param {Cdo_Field_Delivered_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_field_delivered_at = /** @type {((inputs?: Cdo_Field_Delivered_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Field_Delivered_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_field_delivered_at(inputs)
});